import { Link } from 'react-router-dom';
import { Logo } from '../components/Logo';

const NotFoundPage = () => {
  return (
    <div data-testid="not-found-page" className="min-h-screen bg-[#F7F5F0] flex flex-col">
      <header className="bg-[#111111] py-4 px-4 md:px-8 lg:px-16">
        <Link to="/"><Logo variant="light" /></Link>
      </header>
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="text-center max-w-lg">
          <p className="text-[#C5A46D] text-[10px] uppercase tracking-[0.5em] mb-4 font-medium">Page Not Found</p>
          <h1 className="font-heading text-5xl md:text-6xl text-[#111] font-semibold mb-4">404</h1>
          <p className="text-[#666] text-base font-light mb-10 leading-relaxed">
            The page you're looking for doesn't exist. Let us help you find the right home instead.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/" className="bg-[#111111] text-white px-8 py-4 font-medium text-sm tracking-wide hover:bg-[#222] transition-colors text-center">
              Back to Home
            </Link>
            <Link to="/blog" className="border border-[#111]/20 text-[#111] px-8 py-4 font-medium text-sm tracking-wide hover:bg-[#111]/5 transition-colors text-center">
              Read Our Insights
            </Link>
          </div>
          <div className="mt-14 pt-8 border-t border-[#111]/[0.06]">
            <p className="text-[#999] text-sm font-light mb-4">Explore our projects:</p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/project/silver-woods" className="text-[#C5A46D] text-sm hover:underline">Silver Woods</Link>
              <Link to="/project/aurelia" className="text-[#C5A46D] text-sm hover:underline">Aurelia</Link>
              <Link to="/project/sneha-avenue" className="text-[#C5A46D] text-sm hover:underline">Sneha Avenue</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
